import { render, staticRenderFns } from "./PinturaHeader.vue?vue&type=template&id=ee8078c6&scoped=true"
import script from "./PinturaHeader.vue?vue&type=script&lang=ts"
export * from "./PinturaHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PinturaHeader.vue?vue&type=style&index=0&id=ee8078c6&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ee8078c6",
  null
  ,true
)

export default component.exports